import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-privacy-notice',
  templateUrl: './privacy-notice.component.html',
  styleUrls: ['./privacy-notice.component.css']
})
export class PrivacyNoticeComponent implements OnInit {
  ShowEU: any;
  SHowAPAC: any;
  Language: string;
  currentYear: any;
  isHK: boolean;

  constructor(private readonly router: Router) { }

  ngOnInit() {
    this.Language = window.location.href;
    this.currentYear = new Date().getFullYear();
    if (this.Language.indexOf('/cn/') !== -1 || this.Language.indexOf('/tw/') !== -1 || this.Language.indexOf('/hk/') !== -1
      || this.Language.indexOf('/jp/') !== -1) {
      this.ShowEU = 'none';
      this.SHowAPAC = 'block';
    } else {
      this.ShowEU = 'block';
      this.SHowAPAC = 'none';
      this.isHK = false;
    }
    if (this.Language.indexOf('/hk/') !== -1) {
      this.isHK = true;
    }
    if (this.Language.indexOf('https://dataprivacy.spglobal.com/sa/#/privacy-notice') !== -1) {
      window.location.assign('https://dataprivacy.spglobal.com/sa/#/sa-privacy-notice');
    }

    if (this.Language.indexOf('https://qx.dataprivacy.spglobal.com/sa/#/privacy-notice') !== -1) {
      window.location.assign('https://qx.dataprivacy.spglobal.com/sa/#/sa-privacy-notice');
    }
    if (this.Language.indexOf('https://qx.dataprivacy.spglobal.com/br/#/privacy-notice') !== -1) {
      window.location.assign('https://qx.dataprivacy.spglobal.com/br/#/br-privacy-notice');
    }
    if (this.Language.indexOf('https://dataprivacy.spglobal.com/br/#/privacy-notice') !== -1) {
      window.location.assign('https://dataprivacy.spglobal.com/br/#/br-privacy-notice');
    }
    console.log(window.location.href);
    console.log(this.ShowEU);
    console.log(this.SHowAPAC);
  }

}
